import {Container, Text, TextContainer, Title} from "./style";
import {LogoSvg} from "shared/ui/logoSvg";
// import {Button} from "@atomaro/ui-kit";
// import {logout, toRem} from "shared/helpers";

export const AdditionalServices = ({serviceName}: {serviceName: string}) => {
  return (
    <Container>
      <LogoSvg
        width={108}
        height={108}
      />
      <TextContainer>
        {/*<Title>Создайте свою пасеку</Title>*/}
        <Title>Сервис "{serviceName}" находится в разработке</Title>
      </TextContainer>
    </Container>
  )
}
